

document.querySelectorAll("section").forEach((section) => {
    section.container = document.createElement("div");
    section.container.classList.add("container");
    while (section.firstChild) {
        section.container.appendChild(section.firstChild);
    }


    if (section.getAttribute("image") != null) {
        section.style.backgroundImage = `url(${section.getAttribute("image")})`;
        section.classList.add("with-background");
    }
    if ( section.getAttribute("color") != null) {
        let color = section.getAttribute("color");
        // If the section has a video or an image, add transparency
        if ((section.getAttribute("video") != null || section.getAttribute("image") != null)
            && color.match("#([0-9A-F]{3}|[0-9A-F]{6})")){
            color = section.getAttribute("color") + "99";
        }
        section.container.style.backgroundColor = color;
    }

    section.appendChild(section.container);

    if (section.getAttribute("video") != null ){
        let video = document.createElement("video");
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        for (let source of section.getAttribute("video").split(",")) {
            let s = document.createElement("source");
            s.src = source.trim();
            s.type = "video/" + source.split(".").pop().toLowerCase() ;
            video.appendChild(s);
        }
        section.classList.add("with-video");
        section.appendChild(video);
    }
});
